<div
    class="fixed inset-0 z-[60] bg-black/30 backdrop-blur-[1.5px] transition-opacity duration-300"
    (click)="close.emit()">
    <div
        class="absolute top-0 right-0 flex h-full w-full max-w-sm flex-col bg-white shadow-xl dark:bg-gray-900"
        (click)="$event.stopPropagation()">
        <div
            class="flex items-center gap-3 border-b border-gray-100 px-4 py-3 dark:border-gray-700">
            <button
                (click)="close.emit()"
                class="-ml-1 flex h-8 w-8 items-center justify-center rounded-full transition-colors hover:bg-gray-100 dark:hover:bg-gray-800">
                <i
                    class="pi pi-arrow-left text-lg text-gray-700 dark:text-gray-300"></i>
            </button>
            <h1 class="text-lg font-semibold text-gray-900 dark:text-white">
                Notifications
            </h1>
        </div>

        @if (!notifications().length) {
            <div class="flex flex-col items-center py-20 text-center">
                <div
                    class="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
                    <i class="pi pi-bell text-2xl text-gray-400"></i>
                </div>
                <h3
                    class="mb-1 text-base font-semibold text-gray-700 dark:text-gray-300">
                    No notifications yet
                </h3>
                <p class="max-w-xs text-sm text-gray-500">
                    You'll see updates about your appointments and shops here
                </p>
            </div>
        } @else {
            <div class="flex-1 space-y-2 overflow-y-auto p-4">
                @for (notif of notifications(); track notif.id) {
                    <app-client-notification-card [notif]="notif" />
                }
            </div>
        }
    </div>
</div>
